<template>
  <component :is="tag" id="main">
    <span v-if="!editMode">{{ text }}</span>
    
    <span v-if="!editMode" @click="switchEditMode" class="edit-icon">&nbsp;<i class="fas fa-edit"></i></span>

    <input v-if="editMode && !multiline"
      ref="textinput"
      :value="text"
      @blur="emitAndSwitch"
      @keydown.enter="$event.target.blur()"
    />
    <textarea v-if="editMode && multiline"
      ref="textinput"
      :value="text"
      @blur="emitAndSwitch"
      @keydown.enter="$event.target.blur()"
    />
  </component>
</template>

<script>
export default {
  name: 'EditableText',
  props: {
    tag: { default: 'div', type: String },
    text: { default: '', type: String },
    multiline: { default: false, type: Boolean }
  },
  data() {
    return {
      editMode: false
    }
  },
  methods: {
    switchEditMode() {
      this.editMode = !this.editMode;
      
      if (this.editMode) { // Move focus to the newly editable text input
        this.$nextTick(() => this.$refs.textinput.focus());
      }
    },
    emitAndSwitch(event) {
      this.$emit('update:text', event.target.value);
      this.switchEditMode();
    }
  }
}
</script>

<style scoped>
.edit-icon > * {
  color: #43dbae;
}

textarea {
  width: 100%;
}

#main > * {
  width: 100%;
}
</style>